export default "__VITE_ASSET__BM9DQx0R__"